module.exports = __webpack_public_path__ + "media/assets/images/category/Baby@2x-7bea2bfd7c0c562defcc78fb1d776e69.png";